import React, { useState, useRef } from "react";
import conscienceData from "../data/conscience.json"; // adjust path

export default function ConscienceSection() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [expandedRegion, setExpandedRegion] = useState(null);
  const contentRefs = useRef({}); // store refs for each region

  // Generate array from 1 to 205 with leading zeros
  const images = Array.from({ length: 203 }, (_, i) =>
    String(i + 1).padStart(2, "0")
  );

  const regions = [
    "Africa",
    "Asia",
    "Europe",
    "North America",
    "Oceana",
    "South America",
  ];

  const toggleRegion = (region) => {
    setExpandedRegion(expandedRegion === region ? null : region);
  };

  return (
    <section className="px-4 py-8">
      <div className="max-w-[584px] mx-auto">
        {/* Top text */}
        <div className="text-justify space-y-3 mb-12">
          <p>
            OAMC represents a harmonious balance between modern aesthetics and
            innovative techniques. Taking influence from contemporary culture,
            traditional menswear, functional and rational design, nature,
            technical innovation, material development, and extensive
            traditional craft, Creative Director Luke Meier creates modern
            menswear for the culture and context of now. Respect for the past is
            important; notions of re-creating the past are not. OAMC is about
            the present; what is aesthetically pleasing now; what is culturally
            relevant now; what is technically possible and valid now.
          </p>
          <p>
            OAMC offers total look including outerwear, knitwear, woven shirts
            and bottoms, shoes, leather goods, eyewear, and accessories.
          </p>
          <p>
            OAMC goods are produced in France, Italy, Portugal, and Japan and
            are offered in limited quantities. The majority of the materials,
            trims, hardware, and other components are custom developed and
            produced for OAMC, and the products which are made represent the
            highest in quality standards.
          </p>
          <p>OAMC is designed in Paris and developed at our Milan atelier.</p>
        </div>

        {/* Video with click overlay */}
        <div className="relative mb-12">
          {!isPlaying ? (
            <div
              className="relative cursor-pointer"
              onClick={() => setIsPlaying(true)}
            >
              {/* Thumbnail */}
              <img
                src="/videos/conscience/conscience_video_thumb.png"
                alt="Video Thumbnail"
                className="w-full max-w-[584px] mx-auto"
              />
            </div>
          ) : (
            <video
              src="/videos/conscience/conscience_video.mp4"
              autoPlay
              controls
              className="w-full max-w-[584px] mx-auto"
            />
          )}
        </div>

        {/* More text */}
        <div className="text-justify space-y-3 mb-12">
          <p>
            FOR FALL WINTER 2019 PROCEEDS FROM THE SALES OF OUR PRODUCT ARE
            DONATED TO THE THE HI, HOW ARE YOU PROJECT, A NON-PROFIT
            ORGANIZATION INSPIRING NEW CONVERSATIONS AROUND MENTAL HEALTH ISSUES
            BY FUNDING AND CREATING THOUGHTFUL MEDIA CONTENT, PROJECTS AND
            EVENTS. THE FOUNDATION, CREATED WITH THE SUPPORT OF DANIEL JOHNSTON
            AND FAMILY, PROVIDES A PLATFORM FOR THE EXCHANGE OF IDEAS AND
            EDUCATION ON MENTAL WELL-BEING. DONATIONS TO THE FOUNDATION FUND
            MENTAL HEALTH AWARENESS, RESEARCH AND EDUCATION.
          </p>
          <p>
            IF YOU EVER WANT TO CONNECT, DROP US A LINE AT
            THISISHOWIMFEELING@OAMC.COM OR REACH OUT TO ONE OF THE FOLLOWING
            ORGANIZATIONS IN YOUR LOCALITY:
          </p>

          {/* Expandable regions */}
          <div className="text-center space-y-3">
            {regions.map((region) => (
              <div key={region}>
                <p
                  className="cursor-pointer font-semibold"
                  onClick={() => toggleRegion(region)}
                >
                  {region}
                </p>

                <div
                  ref={(el) => (contentRefs.current[region] = el)}
                  style={{
                    height:
                      expandedRegion === region
                        ? `${contentRefs.current[region]?.scrollHeight}px`
                        : "0px",
                  }}
                  className="overflow-hidden transition-[height] duration-500 ease-in-out"
                >
                  <div className="mt-2 space-y-1">
                    {conscienceData
                      .filter((item) => item.country === region)
                      .map((item, idx) => (
                        <p key={idx}>
                          <a
                            href={item.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className=""
                          >
                            {item.name}
                          </a>
                        </p>
                      ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* All 205 images */}
        <div className="flex flex-col items-center gap-4">
          {images.map((num) => (
            <img
              key={num}
              src={`/images/conscience/${num}.png`}
              alt={`Conscience ${num}`}
              className="w-full max-w-[584px] mb-12"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
